<template>
  <b-modal
    v-model="isShowModalLayout"
    :size="modalSize"
    :title="modalTitle"
    hide-footer
    hide-header
    :centered="true"
    :no-close-on-backdrop="true"
    :hide-header-close="true"
  >
    <b-container fluid>
      <b-row class="border-bottom mx-0" :class="modalHeaderClass">
        <span class="modalHeader" :class="modalTitleClass">{{ TITLE }}</span>
      </b-row>
      <div class="border-bottom" :class="modalBodyClass">
        <div v-if="asyncMessage" class="my-4 py-2">
          {{ asyncMessage }}
        </div>
        <slot />
      </div>
      <b-row class="float-right py-2" :class="modalFooterClass">
        <b-col v-if="!hideCancel || !hideOk">
          <BaseEButton
            v-if="!hideCancel"
            variant="cancel"
            :class="cancelButtonClass"
            @click="confirmCancelClicked"
            >{{ CANCEL }}</BaseEButton
          >
          <BaseEButton
            v-if="!hideOk"
            :class="okButtonClass"
            @click="confirmOkClicked"
          >
            {{ OK }}
          </BaseEButton>
        </b-col>
      </b-row>
    </b-container>
  </b-modal>
</template>

<script>
export default {
  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
    modalSize: {
      type: String,
      default: 'md',
    },
    modalTitle: {
      type: String,
      default: '',
    },
    modalTitleClass: {
      type: String,
      default: '',
    },
    modalHeaderClass: {
      type: String,
      default: '',
    },
    modalFooterClass: {
      type: String,
      default: '',
    },
    modalBodyClass: {
      type: String,
      default: '',
    },
    okButtonClass: {
      type: String,
      default: '',
    },
    cancelButtonClass: {
      type: String,
      default: '',
    },
    okVariant: {
      type: String,
      default: 'Ok',
    },
    cancelVariant: {
      type: String,
      default: 'Cancel',
    },
    hideCancel: {
      type: Boolean,
      default: false,
    },
    hideOk: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      asyncShow: false,
      asyncMessage: '',
      asyncTitle: '',
      asyncOkText: '',
      asyncCancelText: '',
      asyncResolve: () => {},
      asyncReject: () => {},
    }
  },
  computed: {
    isShowModalLayout() {
      return this.asyncShow || this.showModal
    },
    TITLE() {
      return this.asyncTitle || this.modalTitle
    },
    OK() {
      return this.asyncOkText || this.okVariant
    },
    CANCEL() {
      return this.asyncCancelText || this.cancelVariant
    },
  },
  methods: {
    confirmOkClicked() {
      if (this.asyncShow) {
        this.asyncMessage = ''
        this.asyncShow = false
        this.asyncResolve && this.asyncResolve('OK')
      }
      this.$emit('confirmOkClicked')
    },
    confirmCancelClicked() {
      if (this.asyncShow) {
        this.asyncMessage = ''
        this.asyncShow = false
        this.asyncReject && this.asyncReject()
      }
      this.$emit('confirmCancelClicked')
    },
    showAsync(message, title, okText, cancelText) {
      return new Promise((resolve, reject) => {
        this.asyncMessage = message
        this.asyncShow = true
        this.asyncTitle = title || this.asyncTitle
        this.asyncOkText = okText
        this.asyncCancelText = cancelText
        this.asyncResolve = resolve
        this.asyncReject = reject
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@design';
.modalHeader {
  font-size: 2rem;
  font-weight: 650;
  color: $color-text-primary;
  padding-bottom: 10px;
}
</style>
